import React from "react";
import ParagraphTag from "../../../reusebale/Paragraph";
import LabelTag from "../../../reusebale/label";
import ButtonTag from "../../../reusebale/button";
import { CircleAlert } from "lucide-react";
import * as DataAction from "../../../../store/actions/data/DataAction"
import { useSelector, useDispatch } from "react-redux";
const Info = ({ formField, onFirstNameChange, onLastNameChange, onEmailChange, onPasswordChange, }) => {
  const dispatch = useDispatch();
  return (
    <div className="w-[70%] mx-auto h-full">
      <div className="text-center h-[15%] flex flex-col justify-center">
        <ParagraphTag
          content="Support staff"
          classes="text-darkColor font-popinsSemiBold text-base 2xl:text-lg"
        />
        <div>
          <ParagraphTag
            content="Add info"
            classes="text-[#686868] font-popinsRegular text-xs"
          />
        </div>
      </div>
      <form className="overflow-y-scroll h-[75%] panelScroll px-1">
        <div className=" w-[70%] mx-auto">
          <div className="mt-3 flex justify-between">
            <div className="w-[49%]">
              <LabelTag
                isStaric={false}
                name="First Name"
                classes="!text-xs !font-popinsMedium"
              />
              <input
                value={formField.firstName}
                onChange={(e) => {
                  onFirstNameChange(e.target.value)
                }}
                type="text"
                placeholder="Please enter first name here"
                className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-lg text-darkColor placeholder:text-zinc-700/50"
              />
            </div>
            <div className="w-[49%]">
              <LabelTag
                isStaric={false}
                name="Last Name"
                classes="!text-xs !font-popinsMedium"
              />
              <input
                value={formField.lastName}
                onChange={(e) => {
                  onLastNameChange(e.target.value)
                }}
                type="text"
                placeholder="Please enter last name here"
                className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-lg text-darkColor placeholder:text-zinc-700/50"
              />
            </div>
          </div>
          <div className="mt-2">
            <LabelTag
              isStaric={false}
              name="Email Address"
              classes="!text-xs !font-popinsMedium"
            />
            <input
              value={formField.email}
              onChange={(e) => {
                onEmailChange(e.target.value)
              }}
              type="text"
              placeholder="Please enter email address here"
              className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-lg text-darkColor placeholder:text-zinc-700/50"
            />
          </div>
          <div className="mt-2">
            <LabelTag
              isStaric={false}
              name="Password"
              classes="!text-xs !font-popinsMedium"
            />
            <input
              value={formField.password}
              onChange={(e) => {
                onPasswordChange(e.target.value)
              }}
              type="password"
              placeholder=""
              className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-lg text-darkColor placeholder:text-zinc-700/50"
            />
          </div>
          <div className="bg-[#F4F4F4] flex mt-3 py-4 pl-5">
            <CircleAlert color="#B3B3B3" size={30} />
            <ParagraphTag
              content="The tenant will be provided a temporary system generated password. "
              classes="text-[#B3B3B3] font-popinsRegular text-xs pl-3 w-[60%]"
            />
          </div>
        </div>
      </form>
      <div className="h-[10%] flex justify-center">
        <div className="w-[40%] mx-auto">
          <ButtonTag
            onSubmit={() => {
              dispatch(DataAction.SupportStaffStepsChangeAction(2))
            }}
            name="Next"
            classes="text-base text-center bg-themeColor text-white"
          />
        </div>
      </div>
    </div>
  );
};

export default Info;
